export const getSorterFlag = (el: any, index: number): false | { multiple: number } => {
  // console.log(el, el.fieldType === 'user');
  // console.log(el);
  if (el.fieldType === 'multi_image' || el.fieldType === 'multi_file' || el.fieldType === 'user') {
    return false;
  }
  return { multiple: index };
};
